var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"font-weight-bold"},[_vm._v("Your local may have more than one option available to you for paying your dues. Please work with your local to determine your payment method.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }